import Box from '@mui/material/Box';
import { Theme, useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import React, { ReactNode } from 'react';

interface CardItemLabelValueProps {
  label: string;
  value: string | number | ReactNode;
  isInline?: boolean;
  hint?: string;
  sx?: SxProps<Theme>; // Style
}
const CardItemLabelValue = ({
  label,
  value,
  hint,
  isInline = false,
  sx = {},
}: CardItemLabelValueProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        mb: 0.5,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mr: isInline ? 2 : 0,
        }}
      >
        <Typography variant={'body1'} sx={{ pr: 1, color: theme.palette.text.secondary }}>
          {label}
        </Typography>
      </Box>
      <Typography variant={'body1'} sx={{ textAlign: 'right' }}>
        {hint && value ? (
          <Tooltip title={hint}>
            <>{value}</>
          </Tooltip>
        ) : (
          value
        )}
      </Typography>
    </Box>
  );
};
export { CardItemLabelValue };
